import React from 'react';
import Icon from '../../../components/AppIcon';

const ExperienceLevelStep = ({ selectedLevel, onSelect }) => {
  const levels = [
    {
      id: 'beginner',
      title: 'Başlangıç Seviyesi',
      icon: 'Waves',
      description: 'SUP sporuna yeni başlıyorum veya temel seviyede deneyimim var',
      features: [
        'Temel teknik eğitimleri',
        'Başlangıç seviyesi etkinlikler',
        'Güvenli ve sakin sular',
        'Deneyimli rehberler eşliğinde'
      ]
    },
    {
      id: 'pro',
      title: 'İleri Seviye',
      icon: 'Zap',
      description: 'Deneyimliyim ve zorlu koşullarda paddle yapabilirim',
      features: [
        'İleri seviye teknikler',
        'Zorlu su koşulları',
        'Uzun mesafe turları',
        'Yarışma ve etkinlikler'
      ]
    }
  ];

  return (
    <div className="w-full max-w-5xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-10">
      <div className="text-center mb-8 md:mb-10 lg:mb-12">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[var(--color-foreground)] mb-3 md:mb-4">
          Deneyim Seviyenizi Seçin
        </h2>
        <p className="text-sm md:text-base lg:text-lg text-[var(--color-muted-foreground)] max-w-2xl mx-auto">
          Size en uygun etkinlikleri ve içerikleri önerebilmemiz için deneyim seviyenizi belirtin
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 lg:gap-8">
        {levels?.map((level) => (
          <button
            key={level?.id}
            onClick={() => onSelect(level?.id)}
            className={`w-full p-6 md:p-8 lg:p-10 rounded-xl md:rounded-2xl border-2 transition-smooth text-left ${
              selectedLevel === level?.id
                ? 'border-[var(--color-primary)] bg-[rgba(27,75,102,0.08)] shadow-organic-lg'
                : 'border-[var(--color-border)] bg-[var(--color-card)] hover:border-[var(--color-primary)] hover:shadow-organic'
            }`}
          >
            <div className="flex items-start gap-4 md:gap-5 mb-4 md:mb-6">
              <div
                className={`w-14 h-14 md:w-16 md:h-16 lg:w-20 lg:h-20 rounded-xl md:rounded-2xl flex items-center justify-center flex-shrink-0 ${
                  selectedLevel === level?.id
                    ? 'bg-[var(--color-primary)] text-[var(--color-primary-foreground)]'
                    : 'bg-[var(--color-muted)] text-[var(--color-muted-foreground)]'
                }`}
              >
                <Icon name={level?.icon} size={32} />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-[var(--color-foreground)] mb-2">
                  {level?.title}
                </h3>
                <p className="text-sm md:text-base text-[var(--color-muted-foreground)]">
                  {level?.description}
                </p>
              </div>
              {selectedLevel === level?.id && (
                <Icon name="CheckCircle2" size={24} className="text-[var(--color-primary)] flex-shrink-0" />
              )}
            </div>

            <div className="space-y-3 md:space-y-4">
              {level?.features?.map((feature, index) => (
                <div key={index} className="flex items-center gap-3">
                  <Icon
                    name="Check"
                    size={18}
                    className={selectedLevel === level?.id ? 'text-[var(--color-primary)]' : 'text-[var(--color-muted-foreground)]'}
                  />
                  <span className="text-sm md:text-base text-[var(--color-foreground)]">
                    {feature}
                  </span>
                </div>
              ))}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ExperienceLevelStep;